export default "__VITE_ASSET__DWBo2rBi__"